import { render, staticRenderFns } from "./platformForm.vue?vue&type=template&id=8a75d648&scoped=true"
import script from "./platformForm.vue?vue&type=script&lang=js"
export * from "./platformForm.vue?vue&type=script&lang=js"
import style0 from "./platformForm.vue?vue&type=style&index=0&id=8a75d648&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a75d648",
  null
  
)

export default component.exports